import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 max-w-4xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              {appInfo.title}
            </h2>
            <p className="text-sm md:text-lg text-foreground-500 mb-2">{appInfo.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">{appInfo.description}</p>

            <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-6">
              {appInfo.features.map((feat) => (
                <span
                  key={feat}
                  className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium"
                >
                  <i className="ri-check-line w-3 h-3 flex items-center justify-center"></i>
                  {feat}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-foreground-900 text-white hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill w-5 h-5 flex items-center justify-center"></i>
                iOS 下载
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill w-5 h-5 flex items-center justify-center"></i>
                Android 下载
              </a>
            </div>
          </div>

          <div className="flex-1 max-w-xs lg:max-w-sm">
            <div className="relative rounded-2xl overflow-hidden aspect-[9/16] max-h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20movie%20streaming%20app%20interface%20with%20dark%20cinema%20theme%2C%20film%20poster%20thumbnails%2C%20clean%20UI%20design%2C%20warm%20dark%20background%20with%20accent%20colors%2C%20modern%20app%20design&width=400&height=700&seq=app-mockup-01&orientation=portrait"
                alt="91影视APP - 随时随地畅快观影"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}